export function toggleScrollbarForcer(toggled: boolean): void {
	let scrollbarForcer = document.querySelector('.scrollbar-forcer');
	if (toggled && !scrollbarForcer) {
		scrollbarForcer = document.createElement('div');
		scrollbarForcer.classList.add('scrollbar-forcer');
		document.body.appendChild(scrollbarForcer);
		const scrollbarWidth = /*document.documentElement.clientWidth*/ window.innerWidth - scrollbarForcer.clientWidth;
		//console.log('ScrollbarWidth: ', scrollbarWidth);
		document.body.style.setProperty('--scrollbar-padding', `${scrollbarWidth}px`);
	} else if (scrollbarForcer) {
		//console.log('ScrollbarWidth: 0');
		document.body.style.setProperty('--scrollbar-padding', `0px`);
		scrollbarForcer.remove();
	}
}
